import Model from '../orm/Model'

export default class Device extends Model {
    
    static entity = 'devices'

    static fields() {
        return {
            id: this.attr(null),
            type: this.string(null),
            os_version: this.string(null),
            app_version: this.string(null),
            model_name: this.string(null),
            token: this.attr(null),
            location_permission: this.number(0),
            bluetooth_permission: this.number(0)
        }
    }
}